var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.isLoading),expression:"isLoading"}],style:({ width: '100%', height: '100%' })},[(_vm.rfqID && _vm.salesOrderID)?[_vm._t("default",null,{"rfqID":_vm.rfqID})]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }